import { baseErrorResponseSchema, baseResponseSchema } from 'api/api.config';
import { z } from 'zod';

export const verifyEmailResponseSchema = baseResponseSchema.extend({});

export type VerifyEmailResponseIType = z.infer<
  typeof verifyEmailResponseSchema
>;

export const verifyEmailErrorResponseSchema = baseErrorResponseSchema;

export type VerifyEmailErrorResponseIType = z.infer<
  typeof verifyEmailErrorResponseSchema
>;

export const isVerifyEmailErrorResponse = (
  response: unknown,
): response is VerifyEmailErrorResponseIType => {
  return verifyEmailErrorResponseSchema.safeParse(response).success;
};
